<template>
  <div>
    <div class="index-header">
      <!-- <img class="index-header-bg" src="../assets/imgs/index-bg.png"> -->
      <div class="header-inner">
        <div class="logo-header">
          <img src="../assets/imgs/航眼logo/白色大@2x.png">
          <a v-if="backend_user.avatar != ''" href="http://acv.avicc.cn/sys/login" target="_blank">
            <img v-if="backend_user.avatar" :src="backend_user.avatar">
            <img v-else src="../assets/imgs/missing-face.png">
          </a>
          <button v-else><a href="http://acv.avicc.cn/sys/login" target="_blank">登录</a></button>
        </div>
        <div class="title-box">
          {{ title || '产业研究数据库' }}
          <!-- <img src="../assets/imgs/index-header-title.png" /> -->
        </div>
        <div class="search-box">
          <!-- <ul class="search-ul">
            <li @click="form.type = index + 1" :class="form.type == index + 1 ? 'active' : ''" v-for="(item,index) in typeList" :key="index">{{ item }}</li>
          </ul> -->
          <div class="search-inner">
            <el-cascader :show-all-levels="false" v-model="industryConfig.industryConfigIdList" :options="industryConfigList" :props="optionProps" @change="handleCascaderChange" ref="cascader"> <template slot-scope="{ node, data }">
                <!--点击文本后选中整个节点-->
                <div @click="$event.srcElement.parentNode.previousElementSibling.click()">
                  {{ data.name }}</div>
              </template></el-cascader>

            <div style="display:flex;align-items: center;">
              <el-tooltip content="你还没有输入内容" placement="bottom-start" effect="light" v-model="searchIsNullFlag" :manual="true">
                <img src="../assets/imgs/search.png">
              </el-tooltip>
              <input type="text" placeholder="请输入" v-model="form.key" @keyup.enter="getSearch(null)" @input="searchInputChange">
            </div>

            <button @click="getSearch(null)">查一下</button>
          </div>
          <div class="hot-search">
            <img src="../assets/imgs/hot-search@2x.png">
            热搜：<span v-for="(item,index) in hotKeyList" :key="index" @click="getSearch(item.key)">{{ item.key }}</span>
          </div>
        </div>

        <ul class="industry-ul" v-if="industryList.length > 0">
          <li v-for="(item,index) in industryList" :key="index">{{ item.count }}<span>{{ item.name }}</span>
            <div v-if="index > 0" class="line"></div>
          </li>
          <!-- <li>12<br><span>行业核心</span>

          </li>
          <li>12<br><span>行业核心</span>
            <div class="line"></div>
          </li>
          <li>12<br><span>行业核心</span>
            <div class="line"></div>
          </li> -->
        </ul>
      </div>
    </div>

    <div class="home-center">
      <ul class="product-ul">
        <li @click="jumpToDetail(item)" v-for="(item,index) in columnList" :key="index"><img :src="item.iconIndex ? item.iconIndex : require(`../assets/imgs/index-icon${index > 7 ? index % 8 + 1 : index + 1}@2x.png`)">{{ item.name }}<span v-if="item.count > 0">（{{item.count}}）</span></li>
      </ul>

      <div class="article-box">
        <div class="left">
          <div class="title">{{ articleColumnName }}<span v-if="articleList.length > 0" @click="jumpToDetail(articleList[0])">更多&nbsp;></span></div>
          <ul v-if="articleList.length > 0">
            <li v-for="(item,index) in articleList" :key="index" @click="jumpArticleDetail(item)">
              <img :src="item.image ? item.image[0]: require('../assets/imgs/default-img.png')">
              <!-- <img :src="require('../assets/imgs/img' + (index + 1) + '.png')"> -->
              <div>
                <h2>{{ item.title }}</h2>
                <p>{{ item.introduce }}</p>
                <span>
                  <img src="../assets/imgs/time.png" />{{ item.date }}
                  <img src="../assets/imgs/read.png" />
                  {{ item.readNumber }}
                </span>
              </div>
            </li>
          </ul>
          <h6 v-else>暂无内容</h6>
        </div>
        <div class="right">
          <div class="title">最热文章<span v-if="hotArticleList.length > 0" @click="jumpToDetail(articleList[0])">更多&nbsp;></span></div>
          <ul v-if="hotArticleList.length > 0">
            <li v-for="(item,index) in hotArticleList" :key="index" @click="jumpArticleDetail(item)">
              <img src="../assets/imgs/index-first@2x.png" v-if="index == 0" />
              <img src="../assets/imgs/index-second@2x.png" v-else-if="index == 1" />
              <img src="../assets/imgs/index-third@2x.png" v-else-if="index == 2" />
              <span v-else>{{ index + 1 }}</span>
              <p>{{ item.title }}</p>
            </li>
          </ul>
          <h6 v-else>暂无内容</h6>
        </div>
      </div>

      <div class="skill-box">
        <h2>产业特色</h2>
        <ul>
          <li>
            <div><img src="../assets/imgs/index-icon9@2x.png"></div>
            <h3>遵循产业研究范式</h3>
            <p>参考产业研究理论，遵循产业研究范式构建数据库的结构。</p>
          </li>
          <li>
            <div><img src="../assets/imgs/index-icon10@2x.png"></div>
            <h3>数据资料来源广泛</h3>
            <p>针对不同用户对各类数据的差异化需求，自权威数据源，采集海量行业研究数据。</p>
          </li>
          <li>
            <div><img src="../assets/imgs/index-icon11@2x.png"></div>
            <h3>专业行业研究平台</h3>
            <p>团队基于产业研究理论和航空行业大量实践经验，运用专业分析手段，为用户提供专业的行业研究报告。</p>
          </li>
        </ul>
      </div>

    </div>

    <div class="foot">
      <div class="foot-center">
        <ul class="footer-left">
          <li><img src="../assets/imgs/航眼logo/白色底部@2x.png"></li>
          <li><span>中航咨询（北京）有限公司</span><span style="margin-left:310px">运营管理研究网</span></li>
          <li><span>网址：<a href="http://www.avicc.cn/" target="_blank" style="cursor: pointer;color:#c9c9c9;">http://www.avicc.cn/</a></span><span style="margin-left:300px;">网址：<a href="http://omr.avicc.cn" target="_blank" style="cursor: pointer;color:#c9c9c9;">http://omr.avicc.cn</a></span></li>
          <li>地址：北京市朝阳区来广营诚盈中心5号楼1206</li>
          <li><span>友情链接：</span><span v-for="(item,index) in companyList" :key="index" style="padding-right:10px"><a :href="item.dictValue" target="_blank">{{ item.dictLabel }}</a></span></li>
        </ul>
        <ul class="code_box">
          <li>联系我们</li>
          <li>
            <p>联系人：胡老师</p>
            <p>联系方式：13611332189 <span style="padding-left: 10px;">固定电话：010-87096276-8016</span></p>
          </li>
        </ul>
      </div>
      <p class="icp">©2020 京ICP备19056510号&emsp;增值电信业务经营许可证： 京ICP备19056510号&emsp;</p>
    </div>

  </div>
  <!-- <div class="container">
    <div class="row">
        <div class="col-md-4">col-md-4</div>
        <div class="col-md-4">col-md-4</div>
        <div class="col-md-4">col-md-4</div>
    </div>
    </div> -->
</template>

<script>
import { apiGet, apiPost } from "../assets/http";
// import { devServer } from "../../vue.config.js";
// const baseUrl = devServer.proxy["/dev-api"].target + "/dev-api";
const baseUrl = "/dev-api";
// import { Loading } from "element-ui";
// let loading = Loading.service({
//   lock: true,
//   fullscreen: true,
//   text: "Loading...",
//   // spinner: "el-icon-loading",
//   background: "#FFF",
// });
export default {
  data() {
    return {
      optionProps: {
        value: "industryConfigId",
        label: "name",
        children: "children",
        checkStrictly: true,
        expandTrigger: "hover",
      },
      title: "",
      searchIsNullFlag: false,
      articleColumnName: "",
      typeList: ["标题检索", "全文检索", "作者检索", "关键词检索", "热词检索"],
      columnList: [],
      articleList: [],
      hotArticleList: [],
      hotKeyList: [],
      // 行业维度里欸奥
      industryList: [],
      // 行业配置列表
      industryConfigList: [],
      form: {
        key: null,
        type: 1,
      },
      baseUrl,
      backend_user: {
        avatar: "",
      },
      companyList: [],
      industryConfig: {},
      // loading,
    };
  },
  created() {
    this.industryConfigList = JSON.parse(
      sessionStorage.getItem("industryConfigList")
    );
    // console.log(this.industryConfigList);
    this.industryConfig = JSON.parse(sessionStorage.getItem("industryConfig"));
    this.title = sessionStorage.getItem("headerTitle");
    // this.getIndustryConfig();
    this.getArticleList();
    // 获取搜索热词
    apiGet("/business/web/getSearchHotKey", {}).then((res) => {
      this.hotKeyList = res.data;
    });
    apiPost("/business/web/webIndexColumn", {}).then((res) => {
      res.data.forEach((item) => {
        if (
          item.iconIndex &&
          (item.iconIndex.indexOf("http") == -1 ||
            item.iconIndex.indexOf("https") == -1)
        ) {
          item.iconIndex = baseUrl + item.iconIndex;
        }
      });
      this.columnList = res.data;
      console.log(this.columnList);
    });
    apiGet("/business/web/getIndustry", {}).then((res) => {
      this.industryList = res.data;
    });
  },
  mounted() {
    this.companyList = JSON.parse(sessionStorage.getItem("companyLink"));
    /*浏览器标签页切换会触发"visibilitychange"事件*/
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.backend_user = JSON.parse(localStorage.getItem("backend_user"));
      }
    });
    /*浏览器关闭、浏览器标签页关闭、浏览器刷新均会触发"beforeunload"事件*/
    // window.addEventListener('beforeunload', e => this.handleFn())
    document.documentElement.scrollTop = 0;
  },
  methods: {
    // getIndustryConfig() {
    //   apiGet("/business/web/getIndustryConfig", {}).then((res) => {
    //     this.industryConfigList = res.data;
    //     if (res.data) {
    //       let obj = {
    //         industryConfigType: 1,
    //         industryConfigId: res.data[0].industryConfigId,
    //         industryConfigIdList: [res.data[0].industryConfigId],
    //         name: res.data[0].name,
    //       };
    //       this.industryConfig = obj;
    //       this.getArticleList();
    //       sessionStorage.setItem("industryConfig", JSON.stringify(obj));
    //     }
    //   });
    // },
    getArticleList() {
      apiGet("/business/web/indexArticle", {
        industryConfigType: this.industryConfig.industryConfigType,
        industryConfigId: this.industryConfig.industryConfigId,
      }).then((res) => {
        res.data.articleList.forEach((item) => {
          if (item.image) {
            if (
              item.image[0].indexOf("http") == -1 ||
              item.image[0].indexOf("https") == -1
            ) {
              item.image[0] = baseUrl + item.image[0];
            } 
          }
        });
        this.articleColumnName = res.data.columnName;
        this.articleList = JSON.parse(JSON.stringify(res.data.articleList));
        this.hotArticleList = res.data.hotArticleList;
        // loading.close();
      });
    },
    getSearch(key) {
      console.log(key, this.form.key);
      if (key != null) {
        console.log(key);
        this.form.key = key;
        this.searchIsNullFlag = false;
        console.log(1);
      } else if (key == null) {
        if (this.form.key == null || this.form.key == "") {
          this.searchIsNullFlag = true;
          console.log(2);
        } else {
          this.searchIsNullFlag = false;
        }
      }

      console.log(this.searchIsNullFlag);
      if (!this.searchIsNullFlag) {
        apiGet("/business/web/webIndexSearch", {
          ...this.form,
          industryConfigType: this.industryConfig.industryConfigType,
          industryConfigId: this.industryConfig.industryConfigId,
        }).then((res) => {
          console.log(res.data);
          this.$router.push({
            path: "/detail",
            name: "detail",
            params: {
              columnId: res.data.length > 0 ? res.data[0].columnId : null,
              type: this.form.type,
              jumpType: "search",
              key: this.form.key,
              list: res.data || [],
            },
          });
        });
      }
    },
    jumpToDetail(item) {
      apiGet("/business/web/webIndexSearch", {
        key: "",
        type: 1,
        industryConfigType: this.industryConfig.industryConfigType,
        industryConfigId: this.industryConfig.industryConfigId,
      }).then((res) => {
        console.log(res.data);
        this.$router.push({
          path: "/detail",
          name: "detail",
          params: {
            columnId: item.columnId,
            // type: null,
            type: 1,
            jumpType: "block",
            list: res.data || [],
          },
        });
      });
      // this.startLoading();
    },
    jumpArticleDetail(item) {
      if (item.link != null) {
        window.open(item.link, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: "/article",
          name: "article",
          query: { articleId: item.articleId },
        });
        console.log(routeUrl.href);
        window.open(routeUrl.href, "_blank");
      }
      // this.startLoading();
    },
    handleCascaderChange(value) {
      let industryConfigName = [];
      if (value.length > 1) {
        this.industryConfigList.forEach((item) => {
          if (value.indexOf(item.industryConfigId) != -1) {
            industryConfigName.push(item.name);
            if (item.children) {
              item.children.forEach((item1) => {
                if (value.indexOf(item1.industryConfigId) != -1) {
                  industryConfigName.push(item1.name);
                }
              });
            }
          }
        });
      } else {
        industryConfigName.push(
          this.$refs["cascader"].getCheckedNodes()[0].label
        );
      }
      console.log(industryConfigName);
      let obj = {
        industryConfigType: value.length > 1 ? 2 : 1,
        industryConfigId: value[value.length - 1],
        industryConfigIdList: value,
        name: industryConfigName,
      };
      this.industryConfig = obj;
      this.getArticleList();
      sessionStorage.setItem("industryConfig", JSON.stringify(obj));
      this.$refs.cascader.dropDownVisible = false;
    },
    searchInputChange() {
      if (
        this.searchIsNullFlag &&
        (this.form.key != null || this.form.key != "")
      ) {
        this.searchIsNullFlag = false;
      }
    },
    // startLoading() {
    //   loading = Loading.service({
    //     fullscreen: true,
    //     background: "rgba(0, 0, 0, 0)",
    //   });
    // },
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
.el-row {
  margin: 0 !important;
}
.el-cascader {
  width: 125px;
  text-align: center;
  .el-input__inner {
    width: 100%;
    text-align: center;
  }
}
.el-cascader-node > .el-radio {
  margin-top: 6px;
}
* {
  // font-family: 宋体;
  // font-family: Noto Sans SC;
  font-family: "思源黑体 Normal";
}
</style>

<style lang="less" scoped>
.code_box{
  margin-top: 90px;
  li{
    color: #aeaeae;
  }
}
</style>

